import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import MainPanel from "../components/MainPanel/MainPanel";
import { updateUser } from "../redux/actions";
import DefaultLayout from "../layout/Layout";

const Setting = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const hanldeSignout = async () => {
    localStorage.removeItem("userData");
    dispatch(updateUser({}));
    navigate("/login");
  };

  return (
    <DefaultLayout isLogin={false}>
      <MainPanel>
        <button onClick={hanldeSignout}>Sign out</button>
      </MainPanel>
    </DefaultLayout>
  );
};
export default Setting;
